import { render, staticRenderFns } from "./DropZoneComponent.vue?vue&type=template&id=4f5aeb9d&scoped=true"
import script from "./DropZoneComponent.vue?vue&type=script&lang=js"
export * from "./DropZoneComponent.vue?vue&type=script&lang=js"
import style0 from "./DropZoneComponent.vue?vue&type=style&index=0&id=4f5aeb9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5aeb9d",
  null
  
)

export default component.exports